import Modal from 'components/Modal';

import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import AddStaffForm from './AddStaffFormV2';

type IStaffPickerConfigs = {
  title?: string;
  anybody?: boolean;
  noneSearch?: boolean;
  staffs?: IStaffItemData[];
  filterIds?: string[];
  staffIds?: string[];
};
const _configs: IStaffPickerConfigs = {
  noneSearch: false,
  anybody: false,
  title: 'SELECT STAFF',
  filterIds: [],
  staffs: [],
  staffIds: [],
};
type Ref = {
  open: (configs?: IStaffPickerConfigs) => Promise<IStaffItemData | null>;
}
const ModalChooseStaffContext = forwardRef<Ref>(({ }, ref) => {
  const [open, setOpen] = useState(false);
  const staffsStore = shopSelectors.data.staffs();

  const callBackPickedStaff = useRef<(data: IStaffItemData | null) => void>(() => undefined);

  const [configs, setConfigs] = useState<IStaffPickerConfigs>(_configs);

  const staffs: IStaffItemData[] = useMemo(() => {
    const _staffStore = configs.staffs?.length ? configs.staffs : staffsStore;
    const data = configs.anybody ? _staffStore : _staffStore.filter(o => !o.anyBody);
    if (!configs.filterIds?.length) return data;
    return data.filter(o => {
      if (configs.filterIds?.includes(o.id)) return false;
      return true;
    });
  }, [staffsStore, configs.filterIds, configs.staffs, configs.anybody]);

  const onSelect = (value: string) => {
    setOpen(false);
    const staffItem = staffs.find((item) => item.id === value);
    if (!staffItem) return;
    callBackPickedStaff.current?.(staffItem);
  };

  const handleClose = () => {
    setOpen(false);
    callBackPickedStaff.current?.(null);
  };

  useImperativeHandle(ref, () => ({
    open: async (newConfigs) => {
      setConfigs(newConfigs || _configs);
      setOpen(true);
      return new Promise<IStaffItemData | null>((resolve) => {
        callBackPickedStaff.current = resolve;
      });
    },
  }));

  if (!open) return null;
  return (
    <Modal
      v2
      visible={!!open}
      modalTitle={configs?.title || 'SELECT STAFF'}
      noneBodyStyle
      hiddenOkButton
      onClose={handleClose}
      width={1600}
    >
      <AddStaffForm
        onPickStaff={staff => onSelect(staff.id)}
        staffs={staffs}
        noneSearch={configs.noneSearch}
        loading={false}
        staffIds={configs.staffIds}
      />
    </Modal>
  );
});
ModalChooseStaffContext.displayName = 'ModalChooseStaffFilterRef';
const ModalChooseStaffContextRef = React.createRef<Ref>();
const StaffPickerManager = {
  Portal: () => <ModalChooseStaffContext ref={ModalChooseStaffContextRef} />,
  open: (configs?: IStaffPickerConfigs) => {
    return ModalChooseStaffContextRef.current?.open(configs);
  },
};

export default StaffPickerManager;
